import { render, staticRenderFns } from "./addIntervene.vue?vue&type=template&id=2090068c&scoped=true&"
import script from "./addIntervene.vue?vue&type=script&lang=js&"
export * from "./addIntervene.vue?vue&type=script&lang=js&"
import style0 from "./addIntervene.vue?vue&type=style&index=0&id=2090068c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090068c",
  null
  
)

export default component.exports